import React, {FunctionComponent} from 'react';
import {Page} from 'b302-frontend-library';
import {useQuery} from '@tanstack/react-query';

import {useWhitelistIndexQueryConfig} from '../../../query/Whitelist/Query';
import WhitelistContent from './WhitelistContent';

const Whitelist: FunctionComponent = () => {
    const [whitelistConfig] = useWhitelistIndexQueryConfig();
    const whitelistQuery = useQuery(whitelistConfig);

    return (
        <Page className={'admin-whitelist-page'}>
            { whitelistQuery.data &&
                <WhitelistContent whitelist={whitelistQuery.data} />
            }
        </Page>
    );
};

export default Whitelist
